/**
 * Returns a string trimmed of whitespace from either ends and newline and tab characters removed from the string entirely
 *   @param string The unsanitized string
 */

export default function getCleanedString(string: string): string {
    if (string != null) {
        const removeNewlineRegex = /(?:\r\n|\r|\n|\t)/g;
        return string.trim().replace(removeNewlineRegex, '');
    }
    return null;
}
